<template>
	<div class="news">

		<div class="news-box">
			<div class="content-box">
				<div class="top">
					<div class="title">{{ detail.title }}</div>
<!--					<div class="time">{{ detail.create_time }}</div>-->
				</div>
				<div class="content" v-if="detail.contents" v-html="detail.contents.content_json[0].data.html"></div>
			</div>

		</div>
	</div>

</template>

<script>
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import {
		getContent,
		getContentHotList,
		getPreNextContent
	} from "@/api"
	export default {
		name: "NewsDetail",
		components: {
			Breadcrumb,
		},
		data() {
			return {
				crumb: [{
					title: "资讯详情",
					path: "NewsDetail",
				}, ],
				id: 0,
				detail: {},
				hotList: [],
				preNext: {
					next: null,
					pre: null
				}
			};
		},
		created() {
			this.id = this.$route.query.id
			this.get()
			this.getPreNext()
			this.getHotList()
		},
		watch: {
			$route(to) {
				this.id = to.query.id
				this.get()
				this.getPreNext()
			},
		},
		methods: {
			get() {
				getContent({
					id: this.id
				}).then((res) => {
					this.detail = res.data
					if (this.detail.contents) {
						this.detail.contents.content_json = JSON.parse(this.detail.contents.content_json)
					}
				})
			},
			getPreNext() {
				getPreNextContent({
					id: this.id
				}).then((res) => {
					this.preNext = res.data
				})
			},
			getHotList() {
				getContentHotList({
					page: 1,
					size: 5
				}).then((res) => {
					this.hotList = res.data.list
				})
			},


		},
	};
</script>

<style scoped lang="scss">
	.news {
		width: 1170px;
		margin: 20px auto;

		.banner {
			margin-top: 20px;
			width: 100%;
			height: 200px;
		}

		.content-box {
			/*width: 870px;*/
			background: #ffffff;
			border: 1px solid #eeeeee;
			padding: 0 50px;

			.title {
				font-size: 29px;
				font-weight: bold;
				line-height: 41px;
				color: #333333;
				margin-top: 30px;
			}

			.time {
				font-size: 15px;
				font-weight: 400;
				line-height: 21px;
				color: #666666;
				margin-top: 10px;
			}

			.content {
				font-size: 16px;
				font-weight: 400;
				line-height: 26px;
				color: #333333;
				margin-top: 20px;
			}
		}

		.news-box {
			margin: 20px 0;
			display: flex;
			justify-content: space-between;
			width: 100%;

			.hot-list {
				margin-left: 20px;
				width: 280px;

				.hot-title {
					width: 280px;
					height: 60px;
					line-height: 60px;
					background: #0f114a;
					text-align: center;
					color: #ffffff;
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: bold;
				}

				.hot-box {
					width: 100%;
					border: 1px solid #eeeeee;

					.item {
						display: flex;
						align-items: center;
						padding: 10px 0;
						// height: 80px;
						margin: 0 10px;

						img {
							width: 80px;
							height: 80px;
						}

						.item-content {
							width: 168px;
							font-size: 12px;
							color: #666666;
							height: 100%;
							margin-left: 10px;

							.title {
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								color: #333333;
								font-size: 14px;
							}

							.content {
								height: 34px;
								width: 100%;
								margin: 5px 0;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}
						}
					}
				}
			}
		}

		.pre-next {
			margin-top: 20px;
			display: flex;
			align-items: center;
			border-top: 1px solid #dddddd;
			padding-top: 20px;

			.item {
				width: 385px;
				height: 85px;
				font-size: 15px;
				color: #666666;

				.pre-title {
					font-size: 15px;
					color: #333333;
					font-weight: bold;
					margin-top: 10px;
				}

				.pre-time {
					font-size: 12px;
					color: #333333;

					margin-top: 5px;
				}
			}
		}
	}
</style>
